import React from "react";
import { Table, Checkbox, Pagination } from "semantic-ui-react";
import { getDatePart } from "@common/components/helpers/datetime";
import { UKDateFormat } from "@common/constants/datetime";

const CustomersToMerge = ({ customersToMerge, pageNumber, pageCount, setPageNumber, isSelected, toggleSelected }) => {
    return (
        <Table celled compact striped>
            <Table.Header>
            <Table.Row>
                <Table.HeaderCell> </Table.HeaderCell>
                <Table.HeaderCell>Name</Table.HeaderCell>
                <Table.HeaderCell>Home Venue</Table.HeaderCell>
                <Table.HeaderCell textAlign='center'>Interactions</Table.HeaderCell>
                <Table.HeaderCell textAlign='center'>Age Range</Table.HeaderCell>
                <Table.HeaderCell textAlign='center'>Ethnicity</Table.HeaderCell>
                <Table.HeaderCell textAlign='center'>Gender</Table.HeaderCell>
                <Table.HeaderCell textAlign='center'>Date Created</Table.HeaderCell>
                <Table.HeaderCell textAlign='center'>Customer ID</Table.HeaderCell>
            </Table.Row>
            </Table.Header>
            <Table.Body>
            {customersToMerge.length === 0 && (
                <Table.Row>
                    <Table.Cell colSpan={9} className="text-center text-muted">
                        No customers found.
                    </Table.Cell>
                </Table.Row>
            )}
            {customersToMerge.map((customer) => (
                <Table.Row key={customer.id}>
                <Table.Cell>
                    <Checkbox
                    checked={isSelected(customer)}
                    onChange={(_, { checked }) => toggleSelected(customer, checked)}
                    />
                </Table.Cell>
                <Table.Cell>{`${customer?.forename} ${customer?.surname}`}</Table.Cell>
                <Table.Cell>{customer?.site?.name}</Table.Cell>
                <Table.Cell textAlign='center'>{customer?.customerStats?.interactionCount}</Table.Cell>
                <Table.Cell textAlign='center'>{customer?.ageRange?.name}</Table.Cell>
                <Table.Cell textAlign='center'>{customer?.ethnicity?.name}</Table.Cell>
                <Table.Cell textAlign='center'>{customer?.gender?.name}</Table.Cell>
                <Table.Cell textAlign='center'>{getDatePart(customer?.dateCreated, UKDateFormat)}</Table.Cell>
                <Table.Cell textAlign='center'>{customer.id}</Table.Cell>
                </Table.Row>
            ))}
            </Table.Body>
            <Table.Footer fullWidth className="py-0_5">
            <Table.Row>
                <Table.HeaderCell colSpan='9' textAlign='right'>
                <Pagination size="mini" activePage={pageNumber} totalPages={pageCount} onPageChange={(e, { activePage }) => setPageNumber(Number(activePage))} />
                </Table.HeaderCell>
            </Table.Row>
            </Table.Footer>
        </Table>
    )
}

export default CustomersToMerge;    